import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Institution20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.3509 1.33722C10.1314 1.22101 9.8686 1.22101 9.64909 1.33722L1.14909 5.83722C0.710396 6.06947 0.618683 6.6794 0.969678 7.03039L2.75 8.81071V16.25H0V17.75H20V16.25H17.25V8.81073L19.0303 7.03039C19.3813 6.67939 19.2896 6.06947 18.8509 5.83722L10.3509 1.33722ZM15.75 9.25006H13.25V16.25H15.75V9.25006ZM11.75 9.25006H8.25V16.25H11.75V9.25006ZM6.75 9.25006H4.25V16.25H6.75V9.25006ZM3.81067 7.75006L2.74838 6.68778L10 2.84868L17.2516 6.68778L16.1893 7.75006H3.81067Z'
      fill='currentColor'
    />
  </Svg>
);

Institution20.displayName = 'Institution20';
export default Institution20;
